// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"4b224ff8","228":"ef8fa907","272":"8ec62dfe","352":"c3b4f166","549":"6792fd62","666":"b2c655b9","816":"ce3eb93a","842":"192bcc76","930":"0b18930c","996":"a523cfc8"}[chunkId] + ".chunk.js";
};